import { Modal, Button } from "react-bootstrap";
import React, { useState, useEffect, useHistory } from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const basicSchema = Yup.object().shape({
  name: Yup.string().required("Name name is required"),
  email: Yup.string().required("Description  is required"),
  gender: Yup.string().required("Gender  is required"),
  phoneNumber: Yup.string().required("Phone Number  is required"),
  roleId: Yup.string().required("Role  is required"),
  status: Yup.string().required("Status  is required"),
  address: Yup.string().required("Address  is required"),
  password: Yup.string().required("Password  is required"),
  confPassword: Yup.string().required("confirmation Password  is required"),
  profilePicture: Yup.string().nullable("Profile Picture  is required"),


  //phoneNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required()
});

const Add = ({ showModal, hideModal, getadd }) => {
  const history = useNavigate();
  const [roles, setRoles] = useState([]);
  const getUsers = async () => {
    const response = await axios.get("users/").then(
      // notify()

    );
  }
  const getRoles = async () => {
    const response = await axios.get("/roles", {
    });

    setRoles(response.data);
  };

  const onSubmit = async (values, actions) => {

    await new Promise((resolve) => setTimeout(resolve, 1000));
    addUser(values);
  };

  const { values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit, submitForm } = useFormik({
      initialValues: {
        name: "",
        email: '',
        phoneNumber: "",
        gender: '',
        profilePicture: "",
        roleId: "",
        password: "",
        confPassword: "",
        status: "",
        address: "",



      },
      validationSchema: basicSchema,
      onSubmit
    })

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={val => {
          onChange(name, val);
        }}
      />
    );
  };
  const notifySuccess = () => toast.success('Driver Added.', {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const notifyError = (message = 'Something went wrong ...') => toast.error(message, {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const addUser = async (e) => {

    try {

      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }
      const responce = await axios.post("/users", bodyFormData).then(res => {

        history("/users");
        hideModal();
        getUsers();
        getadd();
        notifySuccess();

      })
        .catch(err => {
          const msg = err.response ? err.response.data.msg : "Something went wrong";
          notifyError(msg);
        });



    } catch (error) {
      const msg = error.response ? error.response.data.msg : "Something went wrong";
      notifyError(msg);

    }
  };
  useEffect(() => {
    getRoles();
    getadd();
  }, []);

  return (


    <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">
      <Modal
        style={{ marginTop: "60px" }}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      >

        <Modal.Header closeButton>
          <Modal.Title>Add User</Modal.Title>
        </Modal.Header>
        <Modal.Body
        >

          <div class="row" >
            <div class="col-md-6">
              <div class="card card-primary">

                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.name && touched.name ? "form-control input-error" : "form-control "}

                    />
                    {errors.name && touched.name && <p className="error">{errors.name}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Email</label>
                    <input
                      type="text"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.email && touched.email ? "form-control input-error" : "form-control "}

                    />
                    {errors.email && touched.email && <p className="error">{errors.email}</p>}

                  </div>


                  <div class="form-group">
                    <label for="inputName">Phone</label>
                    <input
                      type="text"
                      name="phoneNumber"
                      value={values.phoneNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.phoneNumber && touched.phoneNumber ? "form-control input-error" : "form-control "}

                    />
                    {errors.phoneNumber && touched.phoneNumber && <p className="error">{errors.phoneNumber}</p>}

                  </div>
                  <div className="form-group">
                    <label for="inputStatus">Gender</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="gender"
                      value={values.gender}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.gender && touched.gender ? "form-control input-error" : "form-control "}

                    >
                      <option selected>
                        Select Gender
                      </option>

                      <option value="Male"> Male </option>
                      <option value="Female"> Female </option>

                    </select>
                    {errors.gender && touched.gender && <p className="error">{errors.gender}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Address</label>
                    <input
                      type="text"
                      name="address"
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.address && touched.address ? "form-control input-error" : "form-control "}

                    />
                    {errors.address && touched.address && <p className="error">{errors.address}</p>}

                  </div>

                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card card-primary">

                <div class="card-body">







                  <div class="form-group">
                    <label for="inputName">Password</label>
                    <input
                      type="text"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.password && touched.password ? "form-control input-error" : "form-control "}

                    />
                    {errors.password && touched.password && <p className="error">{errors.password}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Confirm Password</label>
                    <input
                      type="text"
                      name="confPassword"
                      value={values.confPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.confPassword && touched.confPassword ? "form-control input-error" : "form-control "}

                    />
                    {errors.confPassword && touched.confPassword && <p className="error">{errors.confPassword}</p>}

                  </div>

                  <div className="form-group">
                    <label for="inputStatus">Role</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="roleId"
                      value={values.roleId}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.roleId && touched.roleId ? "form-control input-error" : "form-control "}

                    >
                      <option selected>
                        Select Role
                      </option>
                      {roles.map((role, index) => {
                        return (
                          <option key={role.id} value={role.id}>
                            {role.role_name}
                          </option>
                        );
                      })}
                    </select>
                    {errors.roleId && touched.roleId && <p className="error">{errors.roleId}</p>}

                  </div>


                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.status && touched.status ? "form-control input-error" : "form-control "}

                    >
                      <option selected>
                        Select Status
                      </option>

                      <option value="Active"> Active </option>
                      <option value="Inactive"> Inactive </option>

                    </select>
                    {errors.status && touched.status && <p className="error">{errors.status}</p>}

                  </div>

                  <div class="form-group">
                    <label for="exampleInputFile">Profile Picture</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="exampleInputFile"
                          name="profilePicture"
                          accept='image/*'

                          onChange={(e) =>
                            setFieldValue('profilePicture', e.currentTarget.files[0])
                          }

                          className={errors.profilePicture && touched.profilePicture ? "form-control input-error" : "form-control "}
                        />

                      </div>

                    </div>
                    {errors.profilePicture && touched.profilePicture && <p className="error">{errors.profilePicture}</p>}
                  </div>

                </div>
              </div>
            </div>



          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={hideModal}>
            Cancel
          </Button>

          <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
            Submit
          </button>

        </Modal.Footer>

      </Modal>
    </form>

  );
};

export default Add;
